import { render, staticRenderFns } from "./PostViewImmo.vue?vue&type=template&id=2272691e&"
import script from "./PostViewImmo.vue?vue&type=script&lang=js&"
export * from "./PostViewImmo.vue?vue&type=script&lang=js&"
import style0 from "./PostViewImmo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports